import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sam-frontend-admin-feeds',
  templateUrl: './feeds.component.html',
  styleUrls: ['./feeds.component.css'],
})
export class FeedsComponent implements OnInit {
  constructor() {
    /* To be worked on at a later time. Comment is here to satisfy SonarQube */
  }

  ngOnInit(): void {
    /* To be worked on at a later time. Comment is here to satisfy SonarQube */
  }
}
